import React from "react";

import propTypes from "prop-types";

import "../assets/styles/components/Movie.scss";
import MovieDetail from "./MovieDetail";
import Modal from "./Modal";
import useModal from "../custom-hooks/useModal";

const Movie = (props) => {
  const { modal, handleCloseModal, handleOpenModal } = useModal();

  const { data } = props;
  const { id, poster_path, title} = data;



  return (
    <div className = "movie">
      <img
        src={`https://image.tmdb.org/t/p/w500/${poster_path}`}
        alt="Movie"
        onClick={handleOpenModal}
      />
      <p>{ title }</p>
      <Modal isOpen={modal} onClose={handleCloseModal} >
        <MovieDetail id={id} />
      </Modal>
    </div>
  );
};

// propsTypes
Movie.propTypes = {
  data: propTypes.object,
  // // title: propTypes.string,
  // // overview: propTypes.string,
  // // id: propTypes.number
  //etc etc solo documentacón
};

// native redux funtions

export default Movie;
